'use client';

import { SessionProvider } from 'next-auth/react';

/**
 * Client providers wrapper for the games app. Currently the next-auth
 * <SessionProvider> so client components can call useSession() (e.g. MazeGame's
 * AI-mode gate). Games' session is the identity-next-minted next-auth JWT resolved
 * via /api/auth/[...nextauth]; for anon visitors SessionProvider resolves to
 * status 'unauthenticated' (NOT a hang), so public games render without a login.
 *
 * MUST wrap every route: game pages are public now (playable without
 * registration), and MazeGame is server-rendered inside the tree, so the
 * provider has to be present on both the SSR and client trees or useSession
 * throws "must be wrapped in a <SessionProvider />".
 */
export function Providers({ children }: { children: React.ReactNode }) {
  return <SessionProvider>{children}</SessionProvider>;
}
